export default __webpack_public_path__ + "static/media/Pandlite 2 Web.be2895fa.png";